const btnOpen = document.querySelector('.js-open-menu');
const btnClose = document.querySelector('.js-close-menu');
const menuContainer = document.querySelector('.js-menu-container');

btnOpen.addEventListener('click', onClickBtnOpen);
btnClose.addEventListener('click', onClickBtnClose);

let activdisplay = getComputedStyle(btnClose).display;

function onClickBtnOpen() {
  document.body.style.overflow = 'hidden';
  btnOpen.classList.add('is-open');
  menuContainer.classList.add('is-open');
  if (btnOpen.classList.contains('is-open')) {
    btnClose.classList.add('is-open');
    btnClose.classList.toggle('block');
    btnOpen.style.display = 'none';
  }
}
function onClickBtnClose() {
  document.body.style.overflow = 'auto';
  btnOpen.classList.remove('is-open');
  btnClose.classList.toggle('block');
  btnClose.classList.remove('is-open');
  menuContainer.classList.remove('is-open');
  btnOpen.style.display = 'block';
}
